(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["race-print-footer"]) return;
  try {
    
  document.addEventListener('click', (event) => {
    const link = event.target instanceof Element ? event.target.closest('[data-race-cookie-preferences]') : null;
    if (!link || typeof window.privacyBanner?.showPreferences !== 'function') return;
    event.preventDefault();
    try {
      Promise.resolve(window.privacyBanner.showPreferences()).catch(() => { window.location.hash = 'shopifyReshowConsentBanner'; });
    } catch {
      window.location.hash = 'shopifyReshowConsentBanner';
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["race-print-header"]) return;
  try {
    
{
  let raceCountryRequestSequence = 0;

  async function refreshRaceCartCountry(completion = Promise.resolve()) {
    const header = document.querySelector('.race-header[data-race-page-type="cart"]');
    if (!header) return;
    const requestSequence = ++raceCountryRequestSequence;
    const form = header.querySelector('.race-header__localization');
    form?.setAttribute('aria-busy', 'true');
    form?.querySelectorAll('select, button').forEach((control) => { control.disabled = true; });

    try {
      const result = await completion;
      if (requestSequence !== raceCountryRequestSequence) return;
      if (result?.userErrors?.length || result?.detail?.didError) throw new Error('Cart update failed');

      const url = new URL(window.location.href);
      url.searchParams.set('section_id', header.dataset.raceSectionId);
      const response = await fetch(url.toString(), { credentials: 'same-origin', cache: 'no-store' });
      if (!response.ok) throw new Error('Country choices could not be refreshed');
      const html = await response.text();
      if (requestSequence !== raceCountryRequestSequence || !header.isConnected) return;

      const parsed = new DOMParser().parseFromString(html, 'text/html');
      const replacement = parsed.querySelector('.race-header');
      if (!replacement || replacement.dataset.raceSectionId !== header.dataset.raceSectionId) {
        throw new Error('Country choices missing');
      }
      const returnUrl = new URL(window.location.href);
      returnUrl.searchParams.delete('section_id');
      returnUrl.searchParams.delete('sections');
      returnUrl.searchParams.delete('country');
      const returnInput = replacement.querySelector('input[name="return_to"]');
      if (returnInput) returnInput.value = returnUrl.pathname + returnUrl.search + returnUrl.hash;
      header.replaceWith(replacement);
    } catch {
      if (requestSequence !== raceCountryRequestSequence || !header.isConnected) return;
      form?.removeAttribute('aria-busy');
      const retry = header.querySelector('[data-race-country-update-error]');
      if (retry) retry.hidden = false;
    }
  }

  document.addEventListener('shopify:cart:lines-update', (event) => {
    if (event.promise) refreshRaceCartCountry(event.promise);
  });
  document.addEventListener('cart-section:restored', () => { refreshRaceCartCountry(); });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["race-print-home"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('race-release-home')) {
    customElements.define('race-release-home', class extends HTMLElement {
      connectedCallback() {
        if (this.abortController) return;
        this.abortController = new AbortController();
        this.addEventListener('click', (event) => {
          const link = event.target.closest('[data-race-interest]');
          if (!link || !this.contains(link)) return;
          const select = this.querySelector('[data-race-interest-select]');
          if (!select) return;
          const option = Array.from(select.options).find((item) => item.dataset.interestKey === link.dataset.raceInterest);
          if (!option) return;
          select.value = option.value;
          select.dispatchEvent(new Event('change', { bubbles: true }));
          this.querySelector('input[type="email"]')?.focus({ preventScroll: true });
        }, { signal: this.abortController.signal });
      }
      disconnectedCallback() {
        this.abortController?.abort();
        this.abortController = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["race-print-product"]) return;
  try {
    
  if (!customElements.get('race-print-customizer')) {
    const p052GlyphRanges = [[32,126],[160,383],[402,402],[506,511],[536,539],[710,711],[713,713],[728,733],[900,906],[908,908],[910,929],[931,974],[977,977],[981,982],[1024,1119],[1122,1123],[1138,1141],[1168,1171],[1174,1181],[1184,1187],[1194,1195],[1198,1203],[1206,1211],[1216,1216],[1227,1228],[1231,1231],[1240,1241],[1250,1251],[1256,1257],[1262,1263],[7808,7813],[7922,7923],[8194,8194],[8211,8213],[8215,8222],[8224,8226],[8230,8230],[8240,8240],[8242,8243],[8249,8250],[8252,8252],[8254,8254],[8260,8260],[8304,8304],[8308,8313],[8319,8319],[8355,8356],[8359,8359],[8364,8364],[8367,8367],[8413,8413],[8453,8453],[8463,8463],[8465,8467],[8470,8470],[8472,8472],[8476,8476],[8478,8478],[8480,8480],[8482,8482],[8486,8486],[8488,8488],[8493,8495],[8501,8503],[8539,8542],[8592,8601],[8616,8616],[8629,8629],[8644,8644],[8646,8646],[8656,8661],[8704,8704],[8706,8707],[8709,8713],[8715,8715],[8717,8717],[8719,8719],[8721,8723],[8725,8725],[8727,8727],[8729,8730],[8733,8736],[8739,8739],[8741,8741],[8743,8747],[8750,8750],[8756,8757],[8759,8759],[8773,8773],[8776,8776],[8800,8802],[8804,8805],[8810,8811],[8834,8839],[8853,8857],[8866,8869],[8891,8891],[8962,8962],[8976,8976],[8992,8993],[9001,9002],[9472,9472],[9474,9474],[9484,9484],[9488,9488],[9492,9492],[9496,9496],[9500,9500],[9508,9508],[9516,9516],[9524,9524],[9532,9532],[9552,9584],[9600,9600],[9604,9604],[9608,9608],[9612,9612],[9616,9619],[9632,9633],[9642,9644],[9650,9650],[9653,9653],[9657,9658],[9660,9660],[9663,9663],[9667,9668],[9670,9671],[9674,9675],[9679,9679],[9688,9689],[9702,9702],[9786,9788],[9792,9792],[9794,9794],[9824,9824],[9827,9827],[9829,9830],[9834,9835],[12314,12315],[61375,61420],[61434,61439],[64256,64260]];
    customElements.define('race-print-customizer', class extends HTMLElement {
      connectedCallback() {
        if (this.abortController) return;
        this.abortController = new AbortController();
        const signal = this.abortController.signal;
        this.form = this.querySelector('form');
        this.nameInput = this.querySelector('[data-race-name]');
        this.timeInput = this.querySelector('[data-race-time]');
        this.eventInput = this.querySelector('[data-race-event]');
        this.dateInput = this.querySelector('[data-race-date]');
        this.courseInput = this.querySelector('[data-race-course]');
        this.variantInput = this.querySelector('[data-race-variant]');
        this.startInput = this.querySelector('[data-race-start]');
        this.artworkInput = this.querySelector('[data-artwork-style]');
        this.artworkVersion = this.querySelector('[data-artwork-version]');
        this.artworkStatus = this.querySelector('[data-artwork-status]');
        this.designState = 'idle';
        this.designRevision = 0;
        if (this.artworkInput) {
          const entry = new URL(window.location.href).searchParams.get('artwork');
          const selected = ['original', 'graphic', 'editorial'].includes(entry) ? entry : 'graphic';
          const matched = Array.from(this.artworkInput.options).find((option) => option.dataset.style === selected);
          this.artworkInput.value = matched.value;
          this.artworkVersion.value = matched.dataset.version;
          this.querySelector('[data-artwork-entry]').value = selected;
          this.artworkInput.addEventListener('change', () => {
            this.artworkVersion.value = this.artworkInput.selectedOptions[0].dataset.version;
            this.clearError();
            this.updateVariant();
            this.updatePreview();
          }, { signal });
        }
        this.distanceInput = this.querySelector('[data-race-distance]');
        this.templateInput = this.querySelector('[data-print-template]');
        this.error = this.querySelector('[data-race-error]');
        this.submitButton = this.querySelector('[data-race-submit]');
        this.ordersEnabled = this.dataset.ordersEnabled === 'true';
        if (!this.form || !this.nameInput || !this.timeInput || !this.variantInput) return;
        this.form.noValidate = true;
        this.form.addEventListener('input', (event) => {
          if (event.target instanceof HTMLInputElement) {
            event.target.setCustomValidity('');
            event.target.removeAttribute('aria-invalid');
          }
          this.clearError();
          this.updatePreview();
        }, { signal });
        this.variantInput.addEventListener('change', () => {
          this.clearError();
          this.updateVariant();
        }, { signal });
        this.startInput?.addEventListener('change', () => {
          this.startInput.setCustomValidity('');
          this.startInput.removeAttribute('aria-invalid');
          this.clearError();
          this.updateVariant();
        }, { signal });
        this.form.addEventListener('submit', (event) => {
          if (!this.ordersEnabled) {
            event.preventDefault();
            this.showError(this.dataset.closedError);
            return;
          }
          const option = this.variantInput.selectedOptions[0];
          if (!option || option.dataset.available !== 'true') {
            event.preventDefault();
            this.showError(this.dataset.unavailableError, this.variantInput);
            return;
          }
          this.nameInput.value = this.nameInput.value.normalize('NFC').trim();
          this.timeInput.value = this.timeInput.value.trim();
          const unsupportedCharacters = this.unsupportedNameCharacters(this.nameInput.value);
          const checks = [
            [this.nameInput, Array.from(this.nameInput.value).length > 0 && Array.from(this.nameInput.value).length <= 40 && !/\p{C}/u.test(this.nameInput.value), this.dataset.nameError],
            [this.nameInput, unsupportedCharacters.length === 0, this.dataset.nameGlyphError.replace('[characters]', unsupportedCharacters.map((character) => /\s/u.test(character) ? `U+${character.codePointAt(0).toString(16).toUpperCase().padStart(4, '0')}` : character).join(' '))],
            [this.timeInput, /^(?!00:00:00$)[0-9]{2}:[0-5][0-9]:[0-5][0-9]$/.test(this.timeInput.value), this.dataset.timeError]
          ];
          if (this.startInput) {
            const selectedStart = this.startInput.selectedOptions[0];
            checks.push([this.startInput, ['Blue start', 'Orange start', 'Pink start'].includes(this.startInput.value) && Boolean(selectedStart?.dataset.previewUrl) && Boolean(selectedStart?.dataset.templateKey), this.dataset.startError]);
          }
          if (this.eventInput) {
            this.eventInput.value = this.eventInput.value.trim();
            checks.push([this.eventInput, this.eventInput.value.length > 0 && this.eventInput.value.length <= 100, this.dataset.eventError]);
          }
          if (this.dateInput) checks.push([this.dateInput, this.dateInput.value !== '' && this.dateInput.validity.valid, this.dataset.dateError]);
          if (this.courseInput) {
            this.courseInput.value = this.courseInput.value.trim();
            let courseValid = this.courseInput.value === '';
            if (!courseValid) {
              try {
                const courseUrl = new URL(this.courseInput.value);
                courseValid = ['https:', 'http:'].includes(courseUrl.protocol) && courseUrl.hostname.length > 0;
              } catch { courseValid = false; }
            }
            checks.push([this.courseInput, courseValid, this.dataset.courseError]);
          }
          checks.forEach(([input]) => {
            input.setCustomValidity('');
            input.removeAttribute('aria-invalid');
          });
          const failed = checks.find(([, valid]) => !valid);
          if (failed) {
            event.preventDefault();
            const [input, , message] = failed;
            input.setCustomValidity(message);
            input.setAttribute('aria-invalid', 'true');
            this.showError(message, input);
            return;
          }
          if (!this.form.checkValidity()) {
            event.preventDefault();
            this.form.reportValidity();
            return;
          }
          if (this.artworkInput && this.artworkInput.value !== 'Original') {
            if (this.designState !== 'ready') {
              event.preventDefault();
              this.showError(this.designState === 'loading' ? this.dataset.designLoading : this.designError || this.dataset.designError);
              return;
            }
            this.clearError();
            return;
          }
          if (this.fontLoadState !== 'ready') {
            event.preventDefault();
            this.showError(this.fontLoadState === 'loading' ? this.dataset.nameFontLoading : this.dataset.nameFontError);
            return;
          }
          const nameWidth = this.measureNameWidth(this.nameInput.value);
          if (!Number.isFinite(nameWidth) || nameWidth <= 0) {
            event.preventDefault();
            this.showError(this.dataset.nameFontError);
            return;
          }
          if (32 * 860 / nameWidth < 22) {
            event.preventDefault();
            this.nameInput.setCustomValidity(this.dataset.nameFitError);
            this.nameInput.setAttribute('aria-invalid', 'true');
            this.showError(this.dataset.nameFitError, this.nameInput);
            return;
          }
          this.clearError();
        }, { signal });
        this.fontLoadState = 'loading';
        this.updateVariant();
        this.updatePreview();
        Promise.resolve().then(() => document.fonts.load('1000px "Race P052"', 'A')).then((faces) => {
          if (signal.aborted) return;
          if (!faces.some((face) => face.status === 'loaded')) throw new Error('Print font unavailable');
          this.fontLoadState = 'ready';
          this.updatePreview();
          if (this.error.textContent === this.dataset.nameFontLoading) this.clearError();
        }).catch(() => {
          if (signal.aborted) return;
          this.fontLoadState = 'error';
          if (this.error.textContent === this.dataset.nameFontLoading) this.showError(this.dataset.nameFontError);
        });
      }

      disconnectedCallback() {
        this.abortController?.abort();
        if (this.designBlobUrl) URL.revokeObjectURL(this.designBlobUrl);
        this.abortController = null;
      }

      clearError() {
        if (!this.error) return;
        if (this.errorInput && this.error.id) {
          const descriptions = (this.errorInput.getAttribute('aria-describedby') || '').split(/\s+/).filter((id) => id && id !== this.error.id);
          if (descriptions.length) this.errorInput.setAttribute('aria-describedby', descriptions.join(' '));
          else this.errorInput.removeAttribute('aria-describedby');
        }
        this.errorInput = null;
        this.error.hidden = true;
        this.error.textContent = '';
      }

      showError(message, input) {
        this.clearError();
        this.error.textContent = message;
        this.error.hidden = false;
        if (input) {
          this.errorInput = input;
          if (this.error.id) {
            const descriptions = new Set((input.getAttribute('aria-describedby') || '').split(/\s+/).filter(Boolean));
            descriptions.add(this.error.id);
            input.setAttribute('aria-describedby', [...descriptions].join(' '));
          }
          input.focus();
        } else this.error.focus();
      }

      unsupportedNameCharacters(name) {
        return [...new Set(Array.from(name).filter((character) => {
          const codepoint = character.codePointAt(0);
          return !p052GlyphRanges.some(([first, last]) => codepoint >= first && codepoint <= last);
        }))];
      }

      measureNameWidth(name) {
        if (this.fontLoadState !== 'ready' || this.unsupportedNameCharacters(name).length) return NaN;
        this.nameMeasureContext ||= document.createElement('canvas').getContext('2d');
        const context = this.nameMeasureContext;
        if (!context) return NaN;
        context.font = '1000px "Race P052"';
        context.textAlign = 'left';
        context.direction = 'ltr';
        let advance = 0;
        let left = Infinity;
        let right = -Infinity;
        for (const character of name) {
          const metrics = context.measureText(character);
          if (!Number.isFinite(metrics.actualBoundingBoxLeft) || !Number.isFinite(metrics.actualBoundingBoxRight)) return NaN;
          if (!/\s/u.test(character)) {
            left = Math.min(left, advance - metrics.actualBoundingBoxLeft);
            right = Math.max(right, advance + metrics.actualBoundingBoxRight);
          }
          advance += metrics.width;
        }
        return (right - left) * 32 / 1000;
      }

      updateVariant() {
        const option = this.variantInput.selectedOptions[0];
        if (!option) return;
        const available = option.dataset.available === 'true';
        this.submitButton.disabled = !this.ordersEnabled || !available;
        this.submitButton.textContent = !this.ordersEnabled ? this.dataset.closedLabel : available ? this.dataset.submitLabel : this.dataset.unavailableLabel;
        this.querySelector('[data-variant-price]').textContent = option.dataset.price;
        this.querySelectorAll('[data-selected-distance]').forEach((node) => { node.textContent = option.textContent.trim(); });
        const distance = this.querySelector('[data-preview-distance]');
        if (distance) distance.textContent = option.textContent.trim();
        const image = this.querySelector('[data-preview-image]');
        const placeholder = this.querySelector('[data-preview-placeholder]');
        const startOption = this.startInput?.selectedOptions[0];
        const source = startOption?.dataset.previewUrl || option.dataset.previewUrl;
        this.submitButton.disabled = !this.ordersEnabled || !available || !source;
        this.distanceInput.value = option.textContent.trim();
        this.templateInput.value = this.startInput ? startOption?.dataset.templateKey || '' : option.dataset.templateKey || '';
        this.updateDesignPreview();
        if (source) {
          if ((!this.artworkInput || this.artworkInput.value === 'Original') && image.getAttribute('src') !== source) image.src = source;
          image.hidden = false;
          placeholder.hidden = true;
        } else {
          image.removeAttribute('src');
          image.hidden = true;
          placeholder.hidden = false;
        }
      }

      async updateDesignPreview() {
        if (!this.artworkInput) return;
        const revision = ++this.designRevision;
        const style = this.artworkInput.selectedOptions[0].dataset.style;
        const boroughCredit = this.querySelector('[data-graphic-source-credit]');
        if (boroughCredit) boroughCredit.hidden = style !== 'graphic';
        const overlay = this.querySelector('.race-product__text-overlay');
        const framedExample = this.querySelector('.race-product__framed-example');
        if (framedExample) framedExample.hidden = style !== 'original';
        if (style === 'original') {
          this.designState = 'original';
          this.artworkStatus.textContent = '';
          if (overlay) overlay.hidden = false;
          return;
        }
        if (overlay) overlay.hidden = true;
        this.designState = 'loading';
        this.artworkStatus.textContent = this.dataset.designLoading;
        const name = this.nameInput.value.normalize('NFC').trim() || 'Jamie Taylor';
        const finish = this.timeInput.value.trim() || '03:42:18';
        const route = ({'Blue start':'blue','Orange start':'orange','Pink start':'pink'})[this.startInput?.value] || 'blue';
        try {
          this.designDataPromise ||= Promise.all([
            import(this.dataset.designRendererUrl),
            fetch(this.dataset.designDataUrl).then((response) => { if (!response.ok) throw new Error(this.dataset.designError); return response.json(); })
          ]).then(([, data]) => data);
          const data = await this.designDataPromise;
          const base = data.templates[style][route];
          const urls = JSON.parse(this.querySelector('[data-artwork-assets]').textContent);
          base.svgPromise ||= fetch(urls[style][route]).then((response) => { if (!response.ok) throw new Error(this.dataset.designError); return response.text(); });
          base.svg = await base.svgPromise;
          if (revision !== this.designRevision || this.abortController.signal.aborted) return;
          const result = window.RivenbrookNYCDesignsV1.render(data, style, route, name, finish);
          const blobUrl = URL.createObjectURL(new Blob([result.svg], {type:'image/svg+xml'}));
          const readyImage = new Image();
          readyImage.src = blobUrl;
          await readyImage.decode();
          if (revision !== this.designRevision || this.abortController.signal.aborted) { URL.revokeObjectURL(blobUrl); return; }
          const image = this.querySelector('[data-preview-image]');
          const old = this.designBlobUrl;
          image.src = blobUrl;
          image.alt = this.artworkInput.value + ' — ' + route + ' start — ' + result.info.display_name + ' — ' + result.info.time;
          image.hidden = false;
          this.querySelector('[data-preview-placeholder]').hidden = true;
          this.designBlobUrl = blobUrl;
          if (old) URL.revokeObjectURL(old);
          this.designState = 'ready';
          this.designError = '';
          this.artworkStatus.textContent = this.artworkInput.selectedOptions[0].textContent;
          this.submitButton.disabled = !this.ordersEnabled || this.variantInput.selectedOptions[0]?.dataset.available !== 'true';
        } catch (error) {
          if (revision !== this.designRevision) return;
          this.designState = 'error';
          this.designError = error.message || this.dataset.designError;
          this.artworkStatus.textContent = this.designError;
          this.submitButton.disabled = true;
          this.querySelector('[data-preview-image]').hidden = true;
          this.querySelector('[data-preview-placeholder]').hidden = false;
        }
      }

      updatePreview() {
        this.updateDesignPreview();
        const namePreview = this.querySelector('[data-preview-name]');
        namePreview.textContent = this.nameInput.value.normalize('NFC').trim() || this.dataset.namePlaceholder;
        if (typeof namePreview.getComputedTextLength === 'function') {
          namePreview.style.fontSize = '32px';
          const measuredWidth = this.measureNameWidth(namePreview.textContent);
          if (measuredWidth > 860) namePreview.style.fontSize = `${Math.max(22, 32 * 860 / measuredWidth)}px`;
        }
        this.querySelector('[data-preview-time]').textContent = this.timeInput.value.trim() || this.dataset.timePlaceholder;
        this.querySelector('[data-order-name]').textContent = this.nameInput.value.normalize('NFC').trim() || this.dataset.namePlaceholder;
        this.querySelector('[data-order-time]').textContent = this.timeInput.value.trim() || this.dataset.timePlaceholder;
        if (this.eventInput) this.querySelector('[data-preview-event]').textContent = this.eventInput.value.trim() || this.dataset.eventPlaceholder;
        if (this.dateInput) {
          let displayDate = this.dataset.datePlaceholder;
          if (/^\d{4}-\d{2}-\d{2}$/.test(this.dateInput.value)) {
            const [year, month, day] = this.dateInput.value.split('-').map(Number);
            const date = new Date(0);
            date.setFullYear(year, month - 1, day);
            date.setHours(12, 0, 0, 0);
            if (!Number.isNaN(date.getTime())) displayDate = new Intl.DateTimeFormat(document.documentElement.lang || 'en', { day: 'numeric', month: 'long', year: 'numeric' }).format(date);
          }
          this.querySelector('[data-preview-date]').textContent = displayDate;
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
